export enum NightPhase {
  ONLY_NECESSARY = "ONLY_NECESSARY",
  IN_PLAY = "IN_PLAY",
  SELECTED_CARDS = "SELECTED_CARDS",
  IN_PLAY_AND_EXTRA_CARDS = "IN_PLAY_AND_EXTRA_CARDS",
  All = "All",
}
